function isDayBefore(d1, d2) {
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1 < d2;
}
function isSameDay(d1, d2) {
  if (!d1 || !d2)
    return Boolean(d1) === Boolean(d2);
  const d1Copy = new Date(d1.getTime());
  const d2Copy = new Date(d2.getTime());
  d1Copy.setHours(0, 0, 0, 0);
  d2Copy.setHours(0, 0, 0, 0);
  return d1Copy.getTime() === d2Copy.getTime();
}
function calculateNextRange(newDay, from, to) {
  if (!from) {
    return {
      from: newDay,
      to: newDay
    };
  } else if (to && isSameDay(from, to) && isSameDay(newDay, from)) {
    return {
      from: void 0,
      to: void 0
    };
  } else if (to && isSameDay(from, to)) {
    if (isDayBefore(newDay, from)) {
      return {
        from: newDay,
        to: from
      };
    } else {
      return {
        from,
        to: newDay
      };
    }
  } else if (!to && isDayBefore(newDay, from)) {
    return {
      from: newDay,
      to: from
    };
  } else if (to) {
    return { from: newDay, to: newDay };
  } else {
    return { from, to: newDay };
  }
}

export { calculateNextRange, isSameDay };
//# sourceMappingURL=utils.es.js.map
